import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import MaterialButton from "../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import UndoIcon from "@mui/icons-material/Undo";
import {
  allOnsiteActiveScreen,
  allOnsiteInactiveScreen,
  deleteOnsiteEmployeeDetails,
  generateOnsitePdf,
  getOnsiteEmployeeDetails,
  onsitechangeStatus,
} from "./onsitequery";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLoading } from "../../context/loading";
import { OnsitePdfURL } from "../Utils/OnsitePdfUrl";
import axios from "axios";
import { useUserDetails } from "../../context/auth";
import _ from "lodash";

const OnsiteTabel = () => {
  const [data, setData] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [alignment, setAlignment] = React.useState("active");
  const { setCirleLoading } = useLoading();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
    sessionStorage.setItem("onSiteApp", JSON.stringify(newAlignment));
  };

  const { AccessData } = useUserDetails();
  const activeListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.NO",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "empid",
        headerName: "Emp Id",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "type",
        headerName: "Employee Type",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "name",
        headerName: "Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "lastVisaExpiryDate",
        headerName: "Visa ExpiryDate",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "visaDaysRemaining",
        headerName: "Visa DaysRemaining",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "updatedate",
        headerName: "Updated Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Action",
        field: "action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: (data || []).map((v, i) => ({
      id: v.id,
      sno: i + 1,
      empid: v?.employeeId,
      type: v?.type,
      name: v?.employeeName,
      lastVisaExpiryDate: v?.lastVisaExpiryDate || "N/A",
      visaDaysRemaining: v?.visaDaysRemaining || "N/A",
      updatedate: v.lastUpdate?.slice(0, 10),
      action: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "DeleteOnsite" && item.can_access
            ) && (
              <Tooltip
                title="Delete"
                placement="top"
                onClick={() => handleInactiveChange(v?.id)}
              >
                <IconButton size="small">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "ViewOnsite" && item.can_access
            ) && (
              <Tooltip
                title="View"
                placement="top"
                onClick={() => handleView(v?.id)}
              >
                <IconButton size="small">
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            )}
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "EditOnsite" && item.can_access
            ) && (
              <Tooltip
                title="Edit"
                placement="top"
                onClick={() => handleEdit(v?.id)}
              >
                <IconButton size="small">
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "PdfOnsite" && item.can_access
            ) && (
              <Tooltip
                onClick={() => handleDownload(v?.id)}
                title="Download Pdf"
                placement="top"
              >
                <IconButton size="small">
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            )}
        </Box>
      ),
    })),
  };
  const inactiveListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.NO",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "empid",
        headerName: "Emp Id",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "type",
        headerName: "Employee Type",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "name",
        headerName: "Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "updatedate",
        headerName: "Relieved Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        headerName: "Action",
        field: "action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: (data || []).map((v, i) => ({
      id: v.id,
      sno: i + 1,

      empid: v?.employeeId,
      type: v?.type,
      name: v?.employeeName,
      updatedate: v.statusChangeDate?.slice(0, 10),
      action: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "DeleteOnsite" && item.can_access
            ) && (
              <Tooltip
                title="Undo"
                placement="top"
                onClick={() => handleUndo(v?.id)}
              >
                <IconButton size="small">
                  <UndoIcon />
                </IconButton>
              </Tooltip>
            )}
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "DeleteOnsite" && item.can_access
            ) && (
              <Tooltip
                title="Delete"
                placement="top"
                onClick={() => permentDelte(v?.id)}
              >
                <IconButton size="small">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          {AccessData &&
            Array.isArray(AccessData) &&
            AccessData.some(
              (item) => item.component === "ViewOnsite" && item.can_access
            ) && (
              <Tooltip
                title="View"
                placement="top"
                onClick={() => handleView(v?.id)}
              >
                <IconButton size="small">
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            )}
        </Box>
      ),
    })),
  };

  useEffect(() => {
    const tabName = JSON.parse(sessionStorage.getItem("onSiteApp"));

if(tabName){
  setAlignment(tabName);
}else{
  setAlignment("active");
}
  }, [])
  

  useEffect(() => {
    fetchData();
  }, [alignment]);

  const fetchData = () => {
    if (alignment == "active") {
      setIsLoading(true);

      request(BASEURL, allOnsiteActiveScreen)
        .then((res) => {
          setData(res?.allOnsiteActiveScreen);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (alignment == "inactive") {
      setIsLoading(true);

      request(BASEURL, allOnsiteInactiveScreen)
        .then((res) => {
          setData(res?.allOnsiteInactiveScreen);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleNewOnsite = () => {
    navigate("/onsite/add-onsite");
  };

  const handleUndo = (id) => {
    setCirleLoading(true);
    request(BASEURL, onsitechangeStatus, {
      input: {
        id: id,
        onsiteStatus: true,
        statusChangeDate: null,
      },
    })
      .then(() => {
        Swal.fire({
          title: "Your data has been successfully undone.",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchData();
        });
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  const handleInactiveChange = (id) => {
    Swal.fire({
      title: "Select a Date",
      html: `<input type="date" id="datepicker" class="swal2-input">`,
      showCancelButton: true,
      confirmButtonText: "Submit",
      preConfirm: () => {
        const selectedDate = document.getElementById("datepicker").value;
        if (!selectedDate) {
          Swal.showValidationMessage("Please select a date!");
          return false;
        }
        return selectedDate;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        request(BASEURL, onsitechangeStatus, {
          input: {
            id: id,
            onsiteStatus: false,
            statusChangeDate: result.value,
          },
        }).then(() => {
          Swal.fire({
            title: "Your data is inactive successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ok",
          }).then(() => {
            fetchData();
          });
        });
      }
    });
  };

  const permentDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then((result) => {
      if (result?.isConfirmed) {
        setIsLoading(true);
        request(BASEURL, deleteOnsiteEmployeeDetails, {
          id: id,
        })
          .then(() => {
            Swal.fire({
              title: "Your data has been successfully deleted.",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Ok",
            }).then(() => {
              fetchData();
            });
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    });
  };

  const handleEdit = (id) => {
    navigate("/onsite/edit-onsite", { state: { id: id, type: "edit" } });
  };
  const handleView = (id) => {
    navigate("/onsite/view-onsite", { state: { id: id, type: "view" } });
  };

  const handleDownload = async (id) => {
    try {
      const res = await request(BASEURL, getOnsiteEmployeeDetails, { id });

      const data = res?.getOnsiteEmployeeDetails?.onsitedoumentationsSet;

      console.log(data, "data");

      let tableHTML = `
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px; /* Reduced font size */
            margin-bottom: 15px; /* Reduced space */
          }
          th, td {
            border: 1px solid #ddd;
            padding: 6px; /* Reduced padding */
            text-align: left;
          }
          th {
            background-color: #3085d6;
            color: white;
            width: 35%;
          }
          td {
            background-color: #f8f9fa;
          }
          .checkbox-container {
            display: flex;
            align-items: center;
            gap: 8px; /* Reduced space */
            margin-bottom: 6px; /* Reduced space */
          }
        </style>
      `;

      data.forEach((user, index) => {
        tableHTML += `
          <div class="checkbox-container">
            <input type="checkbox" id="checkbox-${index}" value="${user.id}">
            <label for="checkbox-${index}">Travel Documents ${index + 1}</label>
          </div>
          <table>
            <tbody>

               
              ${Object.entries(user)
                .map(
                  ([key, value]) => `
                 <tr style="display: ${key == "id" ? "none" : "table-row"};">
                      <th >${
                        key == "documentSubmissionMail"
                          ? "Document Submission Mail"
                          : key == "documentComments"
                          ? "Document Submission Mail Comments"
                          : key == "medicalTestApplied"
                          ? "Medical Test Applied"
                          : key == "medicalTestAppliedComments"
                          ? "Medical Test Applied Comments"
                          : key == "medicalTestReport"
                          ? "Medical Test Report"
                          : key == "medicalTestReportComments"
                          ? "Medical Test Report Comments"
                          : key == "biometric"
                          ? "Biometric"
                          : key == "returnedToCountry"
                          ? "Returned To India"
                          : key == "returnedToCountryComments"
                          ? "Returned To India Comments"
                          : _.capitalize(key)
                      }</th>
                      <td>${value}</td>
                    </tr>
                  `
                )
                .join("")}
            </tbody>
          </table>
        `;
      });

      Swal.fire({
        title: "Select Documents",
        html: tableHTML,
        width: "80%",
        showCancelButton: true,
        confirmButtonText: "Download",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        preConfirm: () => {
          const selectedIds = Array.from(
            document.querySelectorAll(".checkbox-container input:checked")
          ).map((checkbox) => checkbox.value);

          if (selectedIds.length === 0) {
            Swal.showValidationMessage("Please select at least one document.");
            return false;
          }
          return selectedIds;
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          setCirleLoading(true);
          request(BASEURL, generateOnsitePdf, {
            id: id,
            documentIds: result.value,
          }).then(async (res) => {
            const pdfurl = `${OnsitePdfURL}${res?.generateOnsitePdf?.pdfUrl?.slice(
              1
            )}`;
            try {
              const response = await axios.get(pdfurl, {
                responseType: "blob",
              });
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "Onsite Employee.pdf";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
              Swal.fire({
                title: "PDF downloaded successfully.",
                icon: "success",
                showCancelButton: false,
              });
            } catch (error) {
            } finally {
              setCirleLoading(false);
            }
          });
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  On-Site List
                </MaterialTypography>
              </Stack>

              <Tabs
                orientation={tabsOrientation}
                value={alignment}
                onChange={handleChange}
                sx={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "12px",
                  padding: "5px",
                }}
              >
                <Tab
                  label="Active"
                  value="active"
                  sx={{
                    color: "#2c5da8",
                    transition: "0.3s",
                    "&:hover": {
                      backgroundColor: "#e5e8ec",
                      color: "#1348a5",
                      borderRadius: "8px",
                    },
                  }}
                />

                <Tab
                  label="In Active"
                  value="inactive"
                  sx={{
                    color: "#2c5da8",
                    transition: "0.3s",
                    "&:hover": {
                      backgroundColor: "#e5e8ec",
                      color: "#1348a5",
                      borderRadius: "8px",
                    },
                  }}
                />
              </Tabs>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddOnsite" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleNewOnsite}
                  >
                    Add Onsite
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={
            alignment == "active"
              ? activeListTable.rows
              : inactiveListTable.rows
          }
          columns={
            alignment == "active"
              ? activeListTable.columns
              : inactiveListTable.columns
          }
          loading={isLoading}
          noSearch={false}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  {alignment == "active"
                    ? "No active on-site data found."
                    : "No inactive on-site data found."}
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default OnsiteTabel;
